/* education-assist-v2: durable education and appointment attribution */
(function(){
  "use strict";
  var FT="_sth_ft", LT="_sth_lt", VID="_sth_vid";
  var EDU_FIRST="_sth_edu_first", EDU_LAST="_sth_edu_last", EDU_COUNT="_sth_edu_count";
  var APPT_INTENT="_sth_appt_intent", APPT_BOOKED="_sth_appt_booked", APPT_KEY="_sth_appt_key";
  var FT_DAYS=180, VID_DAYS=730;

  function consentOK(){
    try{ var cp=window.Shopify&&window.Shopify.customerPrivacy;
      if(cp&&typeof cp.analyticsProcessingAllowed==="function")
        return cp.analyticsProcessingAllowed()!==false;
    }catch(e){}
    return true;
  }
  function getCookie(n){var m=document.cookie.match('(?:^|; )'+n+'=([^;]*)');return m?decodeURIComponent(m[1]):null;}
  function setCookie(n,v,days){var d=new Date();d.setTime(d.getTime()+days*864e5);
    document.cookie=n+"="+encodeURIComponent(v)+";expires="+d.toUTCString()+";path=/;SameSite=Lax;Secure";}
  function jsonCookie(n){try{return JSON.parse(getCookie(n)||"null");}catch(e){return null;}}
  function uuid(){return(window.crypto&&crypto.randomUUID)?crypto.randomUUID():
    'xxxxxxxxyxxxxxxx'.replace(/[xy]/g,function(c){var r=Math.random()*16|0;return(c==='x'?r:(r&0x3|0x8)).toString(16);});}
  function safe(v,n,rx){v=String(v||"").slice(0,n);return(!rx||rx.test(v))?v:"";}
  function put(out,key,value){if(value!==null&&value!==undefined&&value!=="")out[key]=String(value).slice(0,255);}

  if(!consentOK())return;
  var qs=new URLSearchParams(location.search);
  var touch={
    source:qs.get("utm_source")||"",medium:qs.get("utm_medium")||"",
    campaign:qs.get("utm_campaign")||"",content:qs.get("utm_content")||"",
    ts:new Date().toISOString(),referrer:document.referrer||"",
    landing:location.pathname+location.search
  };
  var vid=getCookie(VID);if(!vid){vid=uuid();setCookie(VID,vid,VID_DAYS);}
  var hasSource=!!touch.source||(touch.referrer&&touch.referrer.indexOf(location.host)===-1);
  if(!getCookie(FT)&&hasSource)setCookie(FT,JSON.stringify(touch),FT_DAYS);
  if(hasSource)setCookie(LT,JSON.stringify(touch),FT_DAYS);

  function educationFromQuery(){
    var source=safe(qs.get("edu_source"),80,/^[a-z0-9-]+$/);
    var module=safe(qs.get("edu_module"),60,/^[a-z0-9_]+$/);
    var action=safe(qs.get("edu_action"),24,/^[a-z0-9_-]+$/);
    if(!source||!module||!action)return null;
    return{source:source,module:module,action:action,ts:new Date().toISOString(),path:location.pathname.slice(0,180)};
  }
  function appointmentKey(){
    var key=safe(getCookie(APPT_KEY),80,/^[a-z0-9-]+$/);
    if(!key){key="sth-"+uuid();setCookie(APPT_KEY,key,FT_DAYS);}
    return key;
  }
  function markAppointmentIntent(meta){
    meta=meta||{};
    var edu=jsonCookie(EDU_LAST)||{};
    var row={ts:new Date().toISOString(),key:appointmentKey(),from:safe(meta.from||location.pathname,180),
      source:safe(meta.source||edu.source,80),module:safe(meta.module||edu.module,60)};
    setCookie(APPT_INTENT,JSON.stringify(row),FT_DAYS);
    return row;
  }
  function markAppointmentBooked(meta){
    meta=meta||{};
    var edu=jsonCookie(EDU_LAST)||{};
    var row={ts:new Date().toISOString(),key:appointmentKey(),from:safe(meta.from||location.pathname,180),
      source:safe(meta.source||edu.source,80),module:safe(meta.module||edu.module,60)};
    setCookie(APPT_BOOKED,JSON.stringify(row),FT_DAYS);
    if(getCookie("cart"))flush();
    return row;
  }

  var arrived=educationFromQuery();
  if(arrived){
    if(!jsonCookie(EDU_FIRST))setCookie(EDU_FIRST,JSON.stringify(arrived),FT_DAYS);
    setCookie(EDU_LAST,JSON.stringify(arrived),FT_DAYS);
    var count=Math.min(999,parseInt(getCookie(EDU_COUNT)||"0",10)+1);
    setCookie(EDU_COUNT,String(count),FT_DAYS);
    if(arrived.action==="appointment")markAppointmentIntent({from:arrived.path,source:arrived.source,module:arrived.module});
  }
  if(/^\/pages\/book-an-appointment\/?$/.test(location.pathname))markAppointmentIntent({from:location.pathname});

  function attrs(){
    var ft=jsonCookie(FT)||touch,lt=jsonCookie(LT)||ft;
    var ef=jsonCookie(EDU_FIRST),el=jsonCookie(EDU_LAST);
    var ai=jsonCookie(APPT_INTENT),ab=jsonCookie(APPT_BOOKED);
    var out={
      "_utm_source":ft.source,"_utm_medium":ft.medium,"_utm_campaign":ft.campaign,
      "_utm_content":ft.content,"_landing_url":ft.landing,"_referrer":ft.referrer,
      "_first_touch_ts":ft.ts,"_visitor_id":vid,"_last_source":lt.source,
      "_last_medium":lt.medium,"_last_content":lt.content
    };
    if(ef){put(out,"_edu_first_source",ef.source);put(out,"_edu_first_module",ef.module);
      put(out,"_edu_first_action",ef.action);put(out,"_edu_first_ts",ef.ts);put(out,"_edu_first_path",ef.path);}
    if(el){put(out,"_edu_last_source",el.source);put(out,"_edu_last_module",el.module);
      put(out,"_edu_last_action",el.action);put(out,"_edu_last_ts",el.ts);put(out,"_edu_last_path",el.path);}
    put(out,"_edu_touch_count",getCookie(EDU_COUNT));
    if(ai){put(out,"_appointment_intent_ts",ai.ts);put(out,"_appointment_intent_from",ai.from);
      put(out,"_appointment_edu_source",ai.source);put(out,"_appointment_edu_module",ai.module);}
    if(ab){put(out,"_appointment_booked_ts",ab.ts);put(out,"_appointment_booked_from",ab.from);}
    if(ai||ab)put(out,"_appointment_key",(ab&&ab.key)||(ai&&ai.key)||appointmentKey());
    return out;
  }
  function flush(){return fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},
    body:JSON.stringify({attributes:attrs()})}).catch(function(){});}

  window.Stienhardt=window.Stienhardt||{};
  window.Stienhardt.attribution={attrs:attrs,flush:flush,visitorId:vid,
    appointmentKey:appointmentKey,markAppointmentIntent:markAppointmentIntent,
    markAppointmentBooked:markAppointmentBooked};

  document.addEventListener("click",function(e){
    var link=e.target&&e.target.closest?e.target.closest('a[href*="/pages/book-an-appointment"],a[href*="calendly.com"]'):null;
    if(!link)return;
    markAppointmentIntent({from:location.pathname});
    if(getCookie("cart"))flush();
  },true);

  try{
    var nativeFetch=window.fetch;
    window.fetch=function(input,init){
      var url=typeof input==="string"?input:(input&&input.url)||"";
      var promise=nativeFetch.apply(this,arguments);
      if(/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)){
        promise.then(function(res){if(res&&res.ok)setTimeout(flush,0);}).catch(function(){});
      }
      return promise;
    };
  }catch(e){}
  if(getCookie("cart"))flush();
})();
